import { render } from "./App.vue?vue&type=template&id=de95dca4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=de95dca4&lang=less"

import exportComponent from "D:\\Working\\Projects\\EcosystemPlus\\src\\Web\\Ecosystem.EInvoice.Web\\Themes\\EInvoice\\Mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__